// extracted by mini-css-extract-plugin
module.exports = {"container":"qi-z","list":"ri-z"};